import {Component} from '@angular/core';
import {BaseSupportModalComponent} from "./base_support.component";
import { FormControl } from "@angular/forms";
import { FormControlASyncValidators, FormControlValidators } from "../../../models/validators/validator";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { SupportService } from "../support.service";
import { ModalSpreaderService } from "./modal_spreader_service";

@Component({
	templateUrl: './change_owner.component.html'
})
export class ChangeOwnerModalComponent extends BaseSupportModalComponent {
	domainUrl: string;
	siteId: string;
	oldOwnerEmail: string;
	domains: string[] = [];
	emails: string[];
	newOwnerEmail: string;
	
	constructor(
		public activeModal: NgbActiveModal,
		public supportService: SupportService,
		public spreader: ModalSpreaderService,
		public asyncValidators: FormControlASyncValidators,
	) {
		super(activeModal, supportService, spreader);
	}
	
	ngOnInit() {
		this.spreader.base.form = this.form;
		
		this.form.addControl(
			'newOwnerEmail',
			new FormControl(
				this.newOwnerEmail,
				[
					FormControlValidators.required(),
					// FormControlValidators.email(), // отключил, т.к. не пропускает "info@грузоперевозки-тюмень.online"
				],
				this.asyncValidators.emailExists()
			)
		);
		
		this.form.valueChanges.subscribe(({ newOwnerEmail }) => {
			this.newOwnerEmail = newOwnerEmail;
		});
	}
	
	async ok() {
		if (
			confirm(`Вы уверены, что хотите сменить владельца для сайта ${this.domainUrl}?`)
		) {
			await this.supportService.changeOwner(
				this.siteId,
				this.oldOwnerEmail,
				this.newOwnerEmail,
				this.spreader.base.comment
			).toPromise();

			this.execute();
		}
	}
}
